import {chemicalLaboratoryId} from './chemical-lab-config';
import {decodeExperiment,encodeExperiment} from './measurement-engine';
import type {Config} from './resources/attenuation-contract';
import {validateConfig as youngValidate,publicResourceUrl as youngUrl,type ResourceConfig as YoungConfig} from './resources/young-v2-contract';
import {isExperiment,validateExperimentConfig} from './resources/measurement-contract';
import {dissolutionId,validateDissolutionConfig} from './resources/dissolution-contract';
export type ResourceConfig=Config;
export function validateResourceConfig(id:string,input:unknown,fromUrl=false){
 if(id===chemicalLaboratoryId){try{const c=decodeExperiment(input as ResourceConfig);if(c.mode!=='measurement'||c.model!=='reference'||!c.laboratory||!['ph','conductivity'].includes(c.measurement))throw Error('Choisissez un mini-laboratoire de mesure ou de réactions avec un catalogue actif.');return {config:encodeExperiment(c),errors:[] as string[]};}catch(e){return {config:{} as ResourceConfig,errors:[e instanceof Error?e.message:'Laboratoire invalide.']};}}
 if(id===dissolutionId)return validateDissolutionConfig(input,fromUrl);
 return isExperiment(id)?validateExperimentConfig(id,input,fromUrl):youngValidate(input,fromUrl);
}
export function resourcePublicUrl(id:string,origin:string,config:Config,version=1){
 if(id===chemicalLaboratoryId)return new URL('/animations/laboratoire?activity=tp5',origin).href;
 if(id!=="young-double-slit"){
  const r=validateResourceConfig(id,config);
  if(r.errors.length)throw new Error(r.errors.join(' · '));
  const u=new URL('/animations/'+id,origin);u.searchParams.set('v',String(version));
  Object.entries(r.config).forEach(([k,v])=>u.searchParams.set(k,String(v)));
  return u.href;
 }
 return youngUrl(origin,config as YoungConfig);
}
